import imageDe from '../images/de/uploader-animas-problem-1.png';
import imageEn from '../images/en/uploader-animas-problem-1.png';
import imageEs from '../images/es/uploader-animas-problem-1.png';
import imageFi from '../images/fi/uploader-animas-problem-1.png';
import imageFr from '../images/fr/uploader-animas-problem-1.png';
import imageIt from '../images/it/uploader-animas-problem-1.png';
import imageNo from '../images/no/uploader-animas-problem-1.png';
import imageSv from '../images/sv/uploader-animas-problem-1.png';

export const uploaderChooseDevicesImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
